import React from "react";
import ReactPlayer from "react-player";
import { PlayerProps, ReactPlayerElement } from "../types";

const playerStyles = {
  position: "absolute",
  overflow: "hidden",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

const config = {
  vimeo: {
    playerOptions: {
      playsinline: true,
      muted: true,
      loop: true,
      controls: false,
      autoplay: false,
      background: true,
    },
  },
};

interface PlayerState {
  width: string;
  height: string;
  minWidth: string;
  minHeight: string;
  prevWindowWidth: number;
}

class Player extends React.Component<PlayerProps> {
  aspectRatioX = 16;
  aspectRatioY = 9;
  player: React.RefObject<ReactPlayerElement> = React.createRef();
  state: PlayerState = {
    width: "100%",
    height: "100%",
    minWidth: "56.25%",
    minHeight: "100%",
    prevWindowWidth: 0,
  };

  handleOnReady = () => {
    this.handleResize();
  };

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    let { prevWindowWidth } = this.state;
    let width: PlayerState["width"] = "";
    let height: PlayerState["height"] = "";
    let minWidth: PlayerState["minWidth"] = "";
    let minHeight: PlayerState["minHeight"] = "";

    if (!this.player?.current?.wrapper) return;

    const { wrapper } = this.player.current;
    // react-player wraps the iframe in an inaccessible div which needs to be
    // sized to control border-radius on mobile devices. Query for it here and
    // update the element's properties manually
    const inaccessibleWrapper: HTMLDivElement | null = wrapper.querySelector(
      "[data-vimeo-initialized]"
    );

    // Exit if it's not in the DOM. This gets called on react-player's onReady
    // event, so will be availble when the media loads
    if (!inaccessibleWrapper) return;

    const { aspectRatioX: x, aspectRatioY: y } = this;

    width = "100%";
    height = `${(y / x) * wrapper.offsetWidth}px`; // 56.25%
    minWidth = `${(x / y) * wrapper.offsetHeight}px`; // 177%
    minHeight = "100%";

    inaccessibleWrapper.style.position = "absolute";
    inaccessibleWrapper.style.top = "50%";
    inaccessibleWrapper.style.left = "50%";
    inaccessibleWrapper.style.transform = `translateX(-50%) translateY(-50%)`;
    inaccessibleWrapper.style.width = width;
    inaccessibleWrapper.style.height = height;
    inaccessibleWrapper.style.minHeight = minHeight;
    inaccessibleWrapper.style.minWidth = minWidth;

    this.setState({ prevWindowWidth });
  };

  render() {
    const { url } = this.props;

    return (
      <ReactPlayer
        onReady={this.handleOnReady}
        ref={this.player}
        url={url}
        style={playerStyles}
        width="100%"
        height="100%"
        config={config}
      />
    );
  }
}

export default Player;
